import React from 'react';
import './ColorToggleImage.scss'; // Updated to import SCSS file

type ColorToggleImageProps = {
    src: string;
    alt?: string;
    startColorized?: boolean;
};

const ColorToggleImage: React.FC<ColorToggleImageProps> = ({ src, alt, startColorized = false }) => {
    const imageClass = startColorized ? 'color-image' : 'grey-image';
    return <img
        className={`color-toggle-image ${imageClass}`}
        style={{ maxWidth: 70 }}
        src={src}
        alt={alt || 'image'} />;
};

export default ColorToggleImage;
